	<template>
  <div class="balance py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn
          v-if="!checkUserRole(['ROLE_SUPPORT'])"
          @click="openModal('CREATE_QUESTIONNAIRE_MODAL')"
          color="primary"
          target="_blank"
          elevation="0"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('questionnaire.label.create.title') }}
          </span>
        </v-btn>
      </template>
    </h-header>
    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="questionnaires"
        :loading="isQuestionnaireLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.type`]="{ item }">
          <span class="text-center">
            {{ $t(`questionnaire.label.type.${item.type}`) }}
          </span>
        </template>
        <template v-slot:[`item.created_at`]="{ item }">
          <span class="text-center">
            {{ formatDate(item.created_at) }}
          </span>
        </template>
        <template v-slot:[`item.published`]="{ item }">
          <IconIsActive
            :is-active="item.published"
            :subtitle="$t(`questionnaire.label.published.${item.published}`)"
          />
        </template>
        <template v-slot:[`item.must_be_sent`]="{ item }">
          <IconIsActive
            :is-active="item.must_be_sent"
            :subtitle="
              $t(`questionnaire.label.mustBeSent.${item.must_be_sent}`)
            "
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-if="!checkUserRole(['ROLE_SUPPORT'])"
                @click="openEditQuestionnaireModal(item.id)"
              >
                <v-list-item-title>
                  <div class="d-flex align-center">
                    <v-icon
                      style="transform: scale(0.85); opacity: 0.75"
                      class="mr-3 grey--text text--lighten-1"
                    >
                      mdi-pencil-outline
                    </v-icon>
                    <span class="body-2">
                      {{ $t('questionnaire.actions.edit') }}
                    </span>
                  </div>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="goToQuestionnaireQuestions(item.id)">
                <v-list-item-title>
                  <div class="d-flex align-center">
                    <v-icon
                      style="transform: scale(0.85); opacity: 0.75"
                      class="mr-3 grey--text text--lighten-1"
                    >
                      mdi-text-box-outline
                    </v-icon>
                    <span class="body-2">
                      {{ $t('questionnaire.actions.goToQuestion') }}
                    </span>
                  </div>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="!item.published && !checkUserRole(['ROLE_SUPPORT'])"
                @click="handlePublishQuestionnaire(item.id)"
              >
                <v-list-item-title>
                  <div class="d-flex align-center">
                    <v-icon
                      style="transform: scale(0.85); opacity: 0.75"
                      class="mr-3 grey--text text--lighten-1"
                    >
                      mdi-arrow-up-bold-box-outline
                    </v-icon>
                    <span class="body-2">
                      {{ $t('questionnaire.actions.publish') }}
                    </span>
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <h-pagination :fetch="fetchQuestionnaires" />
    <QuestionnaireCreate />
    <QuestionnaireUpdate ref="updateModal" />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { questionnaireListHeaders } from './listHeaders/questionnaireListHeaders'
import { checkUserRole } from '@/util/helpers'
import { catalogDate } from '@/util/catalog'
import IconIsActive from '@/components/IconIsActive'
import router from '@/router'
import QuestionnaireCreate from '@/components/questionnaire/QuestionnaireCreate'
import QuestionnaireUpdate from '@/components/questionnaire/QuestionnaireUpdate'
export default {
  name: 'QuestionnaireList',
  components: {
    IconIsActive,
    QuestionnaireCreate,
    QuestionnaireUpdate
  },
  data() {
    return {
      headers: questionnaireListHeaders,
      formatDate: catalogDate,
    }
  },
  computed: {
    ...mapGetters(['isQuestionnaireLoading', 'questionnaires', 'itemsPerPage']),
  },
  methods: {
    ...mapActions(['openModal', 'fetchQuestionnaires', 'publishQuestionnaire', 'showSuccessMessage', 'showErrorMessage']),
    ...mapMutations(['setIsLoading']),
    goToQuestionnaireQuestions(id) {
      router.push(`/questionnaire/questions/${id}`)
    },
    openEditQuestionnaireModal(id) {
      this.$refs.updateModal.open(id);
    },
    handlePublishQuestionnaire(id) {
      this.setIsLoading(true)
      this.publishQuestionnaire(id)
        .then(async () => {
          this.showSuccessMessage(this.$t('questionnaire.label.successPublish'))
          await this.fetchQuestionnaires()
        })
        .catch(({ data }) => {
          this.showErrorMessage(data.message)
        })
        .finally(() => {
          this.setIsLoading(false)
        })
    },
    checkUserRole,
  },
  mounted() {
    this.fetchQuestionnaires()
  },
}
</script>
